<template>
  <div class="table -users">
    <div class="t-body">
      <h3>Пользователи <button @click="inviteUser">пригласить</button></h3>
      <div class="t-head">
        <div class="-row">
          <div class="-cell"></div>
          <div class="-cell">Имя</div>
          <div class="-cell hide-m">Направление</div>
          <div class="-cell ">Роль</div>
          <div class="-cell">Админ</div>
          <div class="-cell hide-m">Активный</div>
        </div>
      </div>
      <micro-loading v-if="loading" />
      <div class="t-data" v-else>
        <div
          @click="editUser(u, i)"
          v-for="(u, i) in users_list"
          :key="u.id"
          class="user -row"
        >
          <div class="-cell" :class="{ '-online': isOnline(u.email) }">
            <img
              :src="$IMAGE(resolveUser(u.email).image)"
              @error="$avatarError"
            />
          </div>
          <div v-if="resolveUser(u.email).image" class="-cell">
            {{ userName(u.email) }}
          </div>
          <div class="-cell" v-else>
            {{ u.email }}
          </div>
          <div :title="$directions(u.directions, true)" class="-cell hide-m">
            <p v-html="$directions(u.directions)"></p>
          </div>
          <div :title="$roles(u.role, true)" class="-cell">
            <p v-html="$roles(u.role)"></p>
          </div>
          <div class="-cell">
            <i v-if="u.admin" class="fas fa-check"></i>
          </div>
          <div class="-cell hide-m">
            <i v-if="u.active" class="fas fa-check"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapState("app", ["users_list"]),
    ...mapGetters("app", ["resolveUser", "isOnline"])
  },
  methods: {
    ...mapActions("app", ["getUsersList", "togglePopup"]),
    userName(email) {
      try {
        const { first_name, last_name } = this.resolveUser(email);
        if (first_name && last_name) {
          if (this.$mediaQuery() === "mobile")
            return `${first_name.charAt(0)}. ${last_name}`;
          else return `${first_name} ${last_name}`;
        } else {
          return email;
        }
      } catch (e) {
        void e;
        return email;
      }
    },
    editUser(u) {
      this.togglePopup({
        type: "user-edit",
        data: u
      });
    },
    inviteUser() {
      this.togglePopup({
        type: "user-invite",
        data: {
          active: true,
          admin: false,
          role: [3],
          directions: [0],
          email: null
        }
      });
    }
  },
  async mounted() {
    await this.getUsersList();
    this.loading = false;
  },
  data() {
    return {
      loading: true
    };
  }
};
</script>
